import React from 'react';
import './blogTiles.css';


function BlogTiles({ title, subtitle, excerpt, thumbnail }) {

    return (
        <div className="blog-tiles">
            <div className="blog-tiles-image-container">
                <img src={thumbnail} alt={title} loading="lazy" />
            </div>
            <div className="blog-tiles-content">
                <div className="blog-tiles-header">
                    <h1>{title}</h1>
                    {subtitle && <h2>{subtitle}</h2>}
                </div>
                <div className="blog-tiles-content-body">
                    <p>{excerpt}</p>
                </div>
            </div>
        </div>
    );
}

export default BlogTiles;